var React = require('react');

function Theme (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M300,122 C300,128.627 305.373,134 312,134 C318.627,134 324,128.627 324,122 C324,115.373 318.627,110 312,110 C305.373,110 300,115.373 300,122 Z M302,122 C302,116.486 306.486,112 312,112 L312,132 C306.486,132 302,127.514 302,122 Z","transform":"translate(-300 -110)"}));
}

Theme.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Theme;

Theme.default = Theme;
